import { Checkbox as CarbonCheckbox } from '@carbon/react';
import type { ComponentProps } from 'react';

type CarbonCheckboxProps = ComponentProps<typeof CarbonCheckbox>;

export interface CdCheckboxProps extends Omit<CarbonCheckboxProps, 'onChange'> {
  /** Simplified change handler – receives the new checked state. */
  onCheckedChange?: (checked: boolean) => void;
}

export const CdCheckbox = ({ onCheckedChange, ...rest }: CdCheckboxProps) => {
  return (
    <CarbonCheckbox {...rest} onChange={(_event, { checked }) => onCheckedChange?.(checked)} />
  );
};
